import { useEffect, useState } from "react";
import ModalElement from "../../../Common/ModalElement";
import { appApis, headerColumn } from "../../../constants";
import { useApiRequest } from "../../../hooks/useApiRequest";
import LoadingElement from "../../../Common/LoadingElement";
import { formatDate } from "../../../utils";

const PaymentDetails = ({ hideModal, show, query }) => {
    const [data, setData] = useState([]);
    const { request, loading } = useApiRequest();

    useEffect(() => {
        request({
            url: `${appApis.paymentLogs}?${query}`,
            showToast: false,
            onSuccess: (responseData) => {
                setData(responseData?.data?.paymentLogs ?? []);
            }
        })
    }, [])

    return <ModalElement show={show} size="full" title={"Payment Details"} onHide={hideModal}>
        <div className="">
            <div className="card-body bg-white">
                <div className="table-responsive overflow-auto" style={{ maxHeight: "400px" }}>
                    {loading ? <LoadingElement /> :
                        data?.length > 0 ? <table className="table table-sm table-bordered mb-0" style={{ backgroundColor: "#f9f9f9" }}>
                            <thead className="table-light">
                                <tr>
                                    {headerColumn.paymentDetails.map((item, index) => <th scope="col" className="text-start" key={index}>{item}</th>)}
                                </tr>
                            </thead>
                            <tbody id="inventory-body">
                                {data?.map((item, index) => <tr key={index}>
                                    <td className="text-start">{index + 1}</td>
                                    <td className="text-start">{item?.invoice_number ?? ""}</td>
                                    <td className="text-start">{formatDate(item?.paymentdate ?? "")}</td>
                                    <td className="text-start">{item?.paidamount ?? ""}</td>
                                    <td className="text-start">{item?.paymentmode ?? ""}</td>
                                    <td className="text-start">{item?.remarks ?? ""}</td>
                                    <td className="text-start">{formatDate(item?.addedtime ?? "")}</td>
                                    <td className="text-start text-capitalize">{item?.addedby ?? ""}</td>
                                </tr>)}
                            </tbody>
                        </table> : <div className="no-data d-flex justify-content-center align-items-center">
                            <p>No data available</p>
                        </div>}
                </div>
            </div>
        </div>
    </ModalElement>
}

export default PaymentDetails;